import { useTranslation } from 'react-i18next';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { useSidebar } from '@/core/hooks/useSidebar';

export function HeaderToggle() {
  const { isOpen, toggle } = useSidebar();
  const { t } = useTranslation('layout');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" onClick={toggle} aria-label={t('header.toggle.label')}>
          {isOpen ? <ChevronsLeft className="w-5 h-5" /> : <ChevronsRight className="w-5 h-5" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{t('header.toggle.label')}</TooltipContent>
    </Tooltip>
  );
}
